'use strict';
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
var CreditCardListFrameController = /** @class */ (function () {
    /*@ngInject*/
    function CreditCardListFrameController($log, $scope, $timeout, $state, $q, $sce, $rootScope, CreditCardService, Util, CartService, AddressService, $filter, SettingsService, Auth, $window, FocusOnService, configurationService, seoMetaService) {
        var self = this;
        self.Auth = Auth;
        self.bearerToken = "";
        self.paymentURL = "";
        self.$sce = $sce;
        self.$state = $state;
        self.uiRouterState = this.$state.current.name;
        self.iframe = "";
        self.CartService = CartService;
        self._$rootScope = $rootScope;
        self.$window = $window;
        self.settingsService = SettingsService;
        this.seoMetaService = seoMetaService;
        this.seoMetaService.updateSeoMetaData(this, 'CreditCardListFrameController');
        this.environment = configurationService.getEnvironmentConfiguration();
        this.getToken();
        this.$window.onmessage = function (e) {
            if (typeof e.data === "string") {
                var message = JSON.parse(e.data);
                if (message.type === "Emerson") {
                    if (message.eventtype === "resize") {
                        if (message.data && message.data.height) {
                            document.getElementById("creditCardListFrameElement").style.height = message.data.height + 'px';
                        }
                        else {
                            document.getElementById("creditCardListFrameElement").style.height = document.documentElement.clientHeight + 'px';
                        }
                    }
                }
                $scope.$digest();
            }
        };
    }
    CreditCardListFrameController.prototype.getToken = function () {
        var _this = this;
        this.Auth.getUserEmail().then(function (email) {
            _this.userEmail = email;
        });
        this.Auth.getToken().then(function (data) {
            _this.bearerToken = data;
            _this.creditCardListURL = _this.$sce.trustAsResourceUrl(_this.environment.cardManagerAppUrl);
        });
    };
    CreditCardListFrameController.prototype.iframeloaded = function () {
        var _this = this;
        var isIframeElement = document.getElementById("creditCardListFrameElement");
        if (isIframeElement && isIframeElement.contentWindow) {
            this.iframe = document.getElementById("creditCardListFrameElement").contentWindow;
            var getEmail = this.Auth.getUserEmail();
            var getAccountInfo = this.settingsService.getAccount();
            var getToken = this.Auth.getToken();
            forkJoin([getToken, getEmail, getAccountInfo])
                .pipe(map(function (result) {
                var mappedResult = {
                    bearToken: null,
                    userEmailAuth: null,
                    isUserImpersonated: false,
                };
                if (result.length > 2) {
                    var token = result[0];
                    var authenticatedUserEmail = result[1];
                    var aInfo = result[2];
                    mappedResult = {
                        bearToken: token,
                        userEmailAuth: authenticatedUserEmail,
                        isUserImpersonated: aInfo.isImpersonated,
                    };
                }
                else {
                    console.error("invalid response from auth(email) and setting services");
                }
                return mappedResult;
            }))
                .subscribe(function (data) {
                var userEmailAuth = data.userEmailAuth, isUserImpersonated = data.isUserImpersonated, bearToken = data.bearToken;
                var sendData = {
                    token: bearToken,
                    isImpersonated: isUserImpersonated,
                    emailId: userEmailAuth,
                    page: "manage-cards",
                };
                _this.message("token", sendData);
            });
        }
    };
    CreditCardListFrameController.prototype.message = function (eventType, request) {
        this.iframe.postMessage({
            eventtype: eventType,
            data: request,
            type: 'Emerson'
        }, '*');
    };
    return CreditCardListFrameController;
}());
export default CreditCardListFrameController;
//# sourceMappingURL=credit-card-list-frame.controller.js.map